// HortiClub bestsellers carousel — same proven, fully generic scroll-amount/
// arrow-disable logic as assets/hortclub-product-teaser.js, just scoped to
// .hortclub-bestsellers. The init guard (data-carousel-init) and the shared,
// pruning resize dispatcher exist for the same reason there: the Theme
// Editor re-injects this script on every section save, and Shopify's
// section re-render replaces the carousel's DOM rather than reusing it.
//
// Round 3 (2026-08): updateArrows() now also drives the mobile-only
// scroll-progress bar (sections/hortclub-bestsellers.liquid's
// [data-carousel-progress-fill]) — reusing the exact same scroll listener
// that already tracked arrow disabled-state, rather than adding a second
// scroll listener on the same track. Mirrors the identical change made to
// assets/hortclub-video-reviews.js.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.hortclub-bestsellers [data-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselInit) return;
    carousel.dataset.carouselInit = 'true';

    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var progressFill = carousel.parentElement
      ? carousel.parentElement.querySelector('[data-carousel-progress-fill]')
      : null;
    if (!track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var firstItem = track.querySelector('li');
      if (!firstItem) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.gap || styles.columnGap || '16') || 16;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll;

      if (progressFill) {
        var pct = maxScroll <= 0 ? 100 : Math.min(100, Math.max(0, (track.scrollLeft / maxScroll) * 100));
        progressFill.style.width = Math.max(pct, 12) + '%';
      }
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    window.hortclubBestsellersCarousels = window.hortclubBestsellersCarousels || [];
    window.hortclubBestsellersCarousels.push({ track: track, updateArrows: updateArrows });
    updateArrows();
  });

  if (!window.hortclubBestsellersResizeInit) {
    window.hortclubBestsellersResizeInit = true;
    window.addEventListener('resize', function () {
      window.hortclubBestsellersCarousels = (window.hortclubBestsellersCarousels || []).filter(function (entry) {
        if (!document.body.contains(entry.track)) return false;
        entry.updateArrows();
        return true;
      });
    });
  }
})();